
import { Form, TimePicker } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
import { MobileTimeField } from '../mobilePickerFields';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const TimePickerPropsDefaults = {
    label: '',
    name: '',
    type: 'Time',
    format: 'HH:mm:ss',
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};
const { RangePicker } = TimePicker;

const StyledPickerTime = styled(TimePicker)`
    .ant-picker-input >input {
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
    }
`;
const StyledPickerRange = styled(RangePicker)`
    .ant-picker-input >input {
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
    }
`;

export const FormTimePicker = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var  _m, _o, _p, _q, _r, _s;
    var inputStyle = {
        width: '100%',
        borderRadius: getBorderRadiusValue((_s = style === null || style === void 0 ? void 0 : style.inputBorderRadius) !== null && _s !== void 0 ? _s : undefined),
        fontSize: (_m = style === null || style === void 0 ? void 0 : style?.inputFontSize) !== null && _m !== void 0 ? (isMobile ? _m/1.1 : _m) : undefined,
        color: (_o = style === null || style === void 0 ? void 0 : style.inputColor) !== null && _o !== void 0 ? _o : undefined,
        backgroundColor: (_p = style === null || style === void 0 ? void 0 : style.inputBackgroundColor) !== null && _p !== void 0 ? _p : undefined,
        borderColor: (_q = style === null || style === void 0 ? void 0 : style.inputBorderColor) !== null && _q !== void 0 ? _q : undefined,
        borderWidth: (_r = style === null || style === void 0 ? void 0 : style.inputBorderWidth) !== null && _r !== void 0 ? _r : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.inputPadding, isMobile),
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _n, _t, _u;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : TimePickerPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : TimePickerPropsDefaults.name;
    var type = (_i = props === null || props === void 0 ? void 0 : props.type) !== null && _i !== void 0 ? _i : TimePickerPropsDefaults.type;
    var dateFormat = (_n = props === null || props === void 0 ? void 0 : props.format) !== null && _n !== void 0 ? _n : TimePickerPropsDefaults.format;
    var placeholder = (_j = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _j !== void 0 ? _j : '';
    var placeholder2 = (_t = props === null || props === void 0 ? void 0 : props.placeholder2) !== null && _t !== void 0 ? _t : '';
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : TimePickerPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : TimePickerPropsDefaults.visible;
    var disabled = (_u = props === null || props === void 0 ? void 0 : props.disabled) !== null && _u !== void 0 ? _u : TimePickerPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    
    const [fieldHidden, setFieldHidden] = useState(false);
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //otherCustom: 后端传的其他数据，其中有displayOnly，hidden等字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    // mobile 端确认后同步 allFieldValues（与桌面 onChange 行为一致）
    const handleMobileValueChange = (val)=>{
        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
            ...prevData,
            [name]: {
                value: val,
                isRequired: prevData[name]?.isRequired,
                type: prevData[name]?.type
            }
        }))
    }

    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            name={name}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, message: requiredText}] : []}
        >
            {isMobile ? (
                // Mobile：底部弹出的滚轮选择器（时/分/秒按 format 显示对应列）
                <MobileTimeField
                    isRange={type === 'Range'}
                    format={dateFormat}
                    placeholders={type === 'Range' ? [placeholder, placeholder2] : [placeholder]}
                    style={inputStyle}
                    disabled={disabled}
                    title={label}
                    onValue={handleMobileValueChange}
                />
            ) : (
                type === 'Range' ? <StyledPickerRange 
                    style={inputStyle}
                    format={dateFormat}
                    placeholder={[placeholder, placeholder2]}
                    inputReadOnly={true}
                    $inputFontSize={inputStyle.fontSize}
                    onChange={(times, timeStrings)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: timeStrings,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    disabled={disabled}
                />  : <StyledPickerTime 
                    style={inputStyle}
                    format={dateFormat}
                    placeholder={placeholder}
                    inputReadOnly={true}
                    $inputFontSize={inputStyle.fontSize}
                    onChange={(time, timeString)=>{
                        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                            ...prevData,
                            [name]: {
                                value: timeString,
                                isRequired: prevData[name]?.isRequired,
                                type: prevData[name]?.type
                            }
                        }))
                    }}
                    disabled={disabled}
                />
            )}
        </Form.Item>
    </div>;
}

